import { useEffect, useRef, useState } from "react";

// Animated counter
function Counter({ target, suffix = "", duration = 1500 }) {
    const [val, setVal] = useState(0);
    const ref = useRef(null);
    const started = useRef(false);

    useEffect(() => {
        const obs = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting && !started.current) {
                        started.current = true;
                        const start = performance.now();
                        const tick = (now) => {
                            const p = Math.min((now - start) / duration, 1);
                            const eased = 1 - Math.pow(1 - p, 3);
                            setVal(target * eased);
                            if (p < 1) requestAnimationFrame(tick);
                        };
                        requestAnimationFrame(tick);
                    }
                });
            },
            { threshold: 0.3 }
        );
        if (ref.current) obs.observe(ref.current);
        return () => obs.disconnect();
    }, [target, duration]);

    const display = target >= 1000 ? `${(val / 1000).toFixed(val >= 1000 ? 0 : 1)}k` : Math.round(val).toString();
    return (
        <span ref={ref} className="font-mono-alt">
            {display}
            {suffix}
        </span>
    );
}

const STATS = [
    { label: "Years of expertise", target: 10, suffix: "+", testid: "stat-years" },
    { label: "Projects delivered", target: 330000, suffix: "+", testid: "stat-projects" },
    { label: "In-house experts", target: 42, suffix: "+", testid: "stat-experts" },
    { label: "Clients collaborated successfully", target: 6000, suffix: "+", testid: "stat-clients" },
];

export default function StatsCounter() {
    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-slate-800/60 rounded-2xl overflow-hidden border border-slate-800" data-testid="stats-counter">
            {STATS.map((s) => (
                <div key={s.label} className="bg-slate-950/90 p-6 md:p-8 relative group" data-testid={s.testid}>
                    <div className="overline mb-3">{s.label}</div>
                    <div className="text-4xl md:text-5xl font-heading font-bold text-slate-50">
                        <Counter target={s.target} suffix={s.suffix} />
                    </div>
                    <div className="absolute bottom-0 left-0 h-0.5 w-0 group-hover:w-full bg-gradient-to-r from-cyan-400 to-blue-500 transition-all duration-500" />
                </div>
            ))}
        </div>
    );
}
